import { createContext, useContext, useState, useMemo } from 'react';

import { IntlProvider } from 'react-intl';
import { flatten } from 'flat';

import Hungarian from '../../assets/locale/hu.json';
import English from '../../assets/locale/en.json';

const locales = {
  hu: { messages: flatten(Hungarian) },
  en: { messages: flatten(English) },
};

const LocaleContext = createContext();

export const useLocale = () => useContext(LocaleContext);

const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState('hu');

  const changeLocale = newlocale => {
    if (Object.keys(locales).includes(newlocale)) {
      setLocale(newlocale);
    }
  };

  const contextValue = useMemo(() => ({ locale, changeLocale }), [locale]);

  return (
    <LocaleContext.Provider value={contextValue}>
      <IntlProvider locale={locale} messages={locales[locale].messages}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export default LocaleProvider;
